/* eslint-disable */
import axios from 'axios'

axios.defaults.headers.get['Accept'] = 'application/json'
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.withCredentials = true
// axios.defaults.xsrfCookieName = 'csrftoken'
// axios.defaults.xsrfHeaderName = 'X-CSRFToken'

const ttAxios = axios.create({
  baseURL: process.env.SERVER_HOST
})

ttAxios.interceptors.response.use(res => {
  return res
})

// ttAxios.interceptors.request.use(
//   config => {
//     config.withCredentials = true
//     return config
//   },
//   err => {
//     Promise.reject(err)
//   }
// )

export default ttAxios



// WEBPACK FOOTER //
// ./src/axios/index.js